import {
  SET_STUDENTS_LIST,
  SET_SINGLE_STUDENTS_DATA,
  SET_STUDENTS_METRICS_DATA,
  SET_STUDENTS_DEGREE_LIST,
  SET_STUDENT_PENDING_DATA,
} from 'modules/Students/actions'

const initialState = {
  studentsList: [],
  singleStudentData: {},
  studentsMetrics: {},
  degreeList: [],
  studentPendingData: {},
  onboarding: {
    listOfCountry: [],
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STUDENTS_LIST:
      return {
        ...state,
        studentsList: action.data,
      }
    case SET_SINGLE_STUDENTS_DATA:
      return {
        ...state,
        singleStudentData: action.data,
      }
    case SET_STUDENTS_METRICS_DATA:
      return {
        ...state,
        studentsMetrics: action.data,
      }
    case SET_STUDENTS_DEGREE_LIST:
      return {
        ...state,
        degreeList: action.data,
      }
    case SET_STUDENT_PENDING_DATA:
      return {
        ...state,
        studentPendingData: action.data,
      }
    case 'SET_NOTIFICATION_CATALOGUES':
      return {
        ...state,
        notificationCatalogue: action.data,
      }
    case 'SET_LIST_OF_COUNTRY':
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          listOfCountry: action.list,
        },
      }
    default:
      return state
  }
}
